import AppConfig from "./AppConfig";
export const DEPRECATION_NOTICE = "Deprecation Notice:";
const deprecationNotice = (deprecatedMessage) => (
  // eslint-disable-next-line no-console
  AppConfig.gl2DevMode() && console.warn(DEPRECATION_NOTICE, deprecatedMessage)
);
export default deprecationNotice;
